import impactImage from '../assets/images/impact.jpg';

// Function to fetch impact stories from the API
export const fetchAllImpactStories = async () => {
    try {
        const response = await fetch('https://api.dmaimpact.org/impact-stories?_format=json');
        const data = await response.json();
        
        console.log('API Response:', data); // Debug log
        
        if (!Array.isArray(data)) {
            console.error('API response is not an array:', data);
            return [];
        }
        
        return data.map((story, index) => {
            try {
                // Safely access nested properties with fallbacks
                const title = story.title?.[0]?.value || 'Untitled Impact Story';
                const body = story.body?.[0]?.value || '';
                const created = story.created?.[0]?.value || new Date().toISOString();
                const image = story.field_image?.[0]?.url || impactImage;
                const alt = story.field_image?.[0]?.alt || title;
                
                // Create description from body content - strip HTML tags first
                const cleanBody = body.replace(/<[^>]*>/g, '');
                const description = cleanBody.length > 200 ? cleanBody.substring(0, 200) + '...' : cleanBody;
                
                return {
                    id: story.nid?.[0]?.value || index + 1,
                    heading: title,
                    description: description,
                    content: body, // Full HTML content for details page
                    image: image,
                    alt: alt,
                    slug: title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''),
                    date: new Date(created).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    }),
                    category: 'Impact Story', // Default category since API doesn't provide categories
                    index: index
                };
            } catch (storyError) {
                console.error('Error processing impact story:', storyError, story);
                return null;
            }
        }).filter(story => story !== null); // Remove any null stories
        
    } catch (error) {
        console.error('Error fetching impact stories:', error);
        return [];
    }
};

// For backward compatibility, export the static data
export const projectData = [
    {
        heading: 'First Impact Story',
        description: 'Description of the first impact story.',
        content: '<p>This is the full content of the first impact story. It can contain HTML formatting and be much longer than the description.</p><p>Here is another paragraph with more details about the impact story.</p>',
        image: impactImage,
        alt: 'impact-story-1',
    },
    {
        heading: 'Second Impact Story',
        description: 'Description of the second impact story.',
        content: '<p>This is the full content of the second impact story. It can contain HTML formatting and be much longer than the description.</p><p>Here is another paragraph with more details about the impact story.</p>',
        image: impactImage,
        alt: 'impact-story-2',
    },
    {
        heading: 'Third Impact Story',
        description: 'Description of the third impact story.',
        content: '<p>This is the full content of the third impact story. It can contain HTML formatting and be much longer than the description.</p><p>Here is another paragraph with more details about the impact story.</p>',
        image: impactImage,
        alt: 'impact-story-3',
    },
    {
        heading: 'Fourth Impact Story',
        description: 'Description of the fourth impact story.',
        content: '<p>This is the full content of the fourth impact story. It can contain HTML formatting and be much longer than the description.</p><p>Here is another paragraph with more details about the impact story.</p>',
        image: impactImage,
        alt: 'impact-story-4',
    },
];
